import { format } from 'date-fns';

import { I18nLocale } from '#/i18n/types/I18nLocale';

import { type DateInput, normalizeDateInput } from './domain';
import { getDateFnsLocale, getLocaleCode } from './locale';

export function legacy_humanDate_yearFormat_long_space_humanTime({
  date,
  locale,
}: {
  date: DateInput;
  locale: I18nLocale;
}) {
  const HUMAN_DATETIME_FORMAT = {
    en: 'MMM d, yyyy h:mm a',
    es: 'MMM d, yyyy H:mm',
    pt: 'MMM d, yyyy H:mm',
  } satisfies Record<I18nLocale, string>;

  return format(normalizeDateInput(date), HUMAN_DATETIME_FORMAT[locale], {
    locale: getDateFnsLocale(locale),
  });
}

export function legacy_shortDate_yearFormat_short({
  date,
  locale,
}: {
  date: DateInput;
  locale: I18nLocale;
}) {
  const SHORTEST_DATE_WITH_YEAR_FORMAT = {
    en: 'M/d/yy',
    es: 'd/M/yy',
    pt: 'd/M/yy',
  } satisfies Record<I18nLocale, string>;

  return format(
    normalizeDateInput(date),
    SHORTEST_DATE_WITH_YEAR_FORMAT[locale],
    {
      locale: getDateFnsLocale(locale),
    },
  );
}

export function legacy_shortDate_yearFormat_long_space_humanTime({
  date,
  locale,
}: {
  date: DateInput;
  locale: I18nLocale;
}) {
  const DATETIME_FORMAT = {
    en: 'MM/dd/yyyy hh:mma',
    es: 'dd/MM/yyyy HH:mm',
    pt: 'dd/MM/yyyy HH:mm',
  } satisfies Record<I18nLocale, string>;

  return format(normalizeDateInput(date), DATETIME_FORMAT[locale], {
    locale: getDateFnsLocale(locale),
  });
}

export function legacy_shortDate_yearFormat_short_space_humanTime({
  date,
  locale,
}: {
  date: DateInput;
  locale: I18nLocale;
}) {
  const SHORT_DATETIME_FORMAT_BY_LOCALE = {
    en: 'M/d/yy h:mma',
    es: 'd/M/yy HH:mm',
    pt: 'd/M/yy HH:mm',
  } satisfies Record<I18nLocale, string>;

  return format(
    normalizeDateInput(date),
    SHORT_DATETIME_FORMAT_BY_LOCALE[locale],
    { locale: getDateFnsLocale(locale) },
  );
}

export function legacy__humanTime({
  date,
  locale,
  timezone,
  displayTimezone,
}: {
  date: DateInput;
  locale: I18nLocale;
  timezone?: string | null;
  displayTimezone?: boolean;
}) {
  const instant = date;
  const timeZone = timezone;

  const localeCode = getLocaleCode(locale);

  return new Date(instant).toLocaleTimeString(localeCode, {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timeZone ?? undefined,
    timeZoneName: displayTimezone ? 'short' : undefined,
  });
}
